import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Fetch a Verkada camera thumbnail and save it to the backend.
 * 
 * @param {Object} params
 * @param {string} params.module - 'kasse' or 'shipping'
 * @param {string} params.cameraId - Verkada camera ID
 * @param {number} params.timestampMs - Event timestamp in ms
 * @param {Object} params.savePayload - Extra fields for save endpoint (e.g. {epoch_timestamp: ...} or {tracking_number: ...})
 * @param {string} params.userToken - User session token
 * @param {Function} params.onSuccess - Callback after successful save
 * @param {number} [params.delay=3000] - Delay before fetching (ms)
 */
export const fetchAndSaveThumbnail = ({ module, cameraId, timestampMs, savePayload, userToken, onSuccess, delay = 3000 }) => {
  setTimeout(async () => {
    try {
      const thumbnailResponse = await axios.get(`${API}/${module}/thumbnail`, {
        params: { camera_id: cameraId, timestamp_ms: timestampMs },
        headers: { 'X-User-Session-Token': userToken }
      });

      if (thumbnailResponse.data.success) {
        await axios.post(`${API}/${module}/save-thumbnail`, {
          ...savePayload,
          thumbnail: thumbnailResponse.data.image
        }, {
          headers: { 'X-User-Session-Token': userToken }
        });
        if (onSuccess) onSuccess();
      }
    } catch (error) {
    }
  }, delay);
};
